export default __webpack_public_path__ + "static/media/default_gray@3x.21edcb75.webp";